import React from 'react'
import { usePersonalSetup } from '../contexts/PersonalSetupContext'
import PersonalSetupWizard from './setup-wizard/PersonalSetupWizard'

interface PersonalSetupGuardProps {
  children: React.ReactNode
}

export default function PersonalSetupGuard({ children }: PersonalSetupGuardProps) {
  const { shouldShowWizard } = usePersonalSetup()

  return (
    <>
      {children}
      {shouldShowWizard && <PersonalSetupWizard />}
    </>
  )
}